import React, {useEffect, useState} from "react";
import {useSimple3DComp} from "../Hooks.js";
import {LHQInstance} from "../Scene.js";
import {bakedWebDir, LoadBakedManifest} from "../BakedLightmaps.js";

// Components for the single-blend (LHQ_<N>.blend) pipeline: one .gltf per load-group, with Blender-baked lightmaps.
// Regenerate the assets via: Scripts/Blender/BlenderExport.py (in Blender), then `node Scripts/Blender/Optimize.js`.
// The full list of load-groups comes from LHQ_Web/manifest.json (written by the export, in blend order), so it can't drift from the blend.
// (a load-group = a subcollection of a top-level collection, or "<TopLevel>" for objects directly in one; see BlenderExport.py)

/** Load-groups used by the non-"full" mode (replaces the manifest's full list). */
export const bakedLHQGroups_minimal = ["Floor", "Walls", "Ceiling"];

/** Every load-group in the manifest, in blend order; null until the manifest is loaded (or if it fails to load). */
function useBakedLHQGroups_full() {
	const [groups, setGroups] = useState<string[]|n>(null);
	useEffect(()=>{
		let cancelled = false;
		LoadBakedManifest().then(manifest=>{
			if (cancelled || manifest == null) return;
			setGroups(Object.keys(manifest.collections));
		});
		return ()=>{ cancelled = true; };
	}, []);
	return groups;
}

export const BakedLHQ = ({lhq, full}: {lhq: LHQInstance, full: boolean})=>{
	const fullGroups = useBakedLHQGroups_full();
	const names = full ? (fullGroups ?? []) : bakedLHQGroups_minimal;
	return <>{names.map(name=><BakedLHQComp key={name} lhq={lhq} name={name}/>)}</>;
};

export const BakedLHQComp = ({lhq, name}: {lhq: LHQInstance, name: string})=>useSimple3DComp(lhq, {
	path: `${bakedWebDir}/${name}.gltf`,
	baked: true,
});